const initialActivitieListFilters = {
  ordered_field: 'created_date',
  ordered_desc: true,
  page: 1,
  pages: 1,
};

export default initialActivitieListFilters;
